import { FormItem } from 'element-ui'
import './style.scss'

const YFormItem = FormItem
YFormItem.$depends = [FormItem]
YFormItem.$name = 'y-form-item'
YFormItem._name = 'FormItem 表单选项'

export default YFormItem
